import { getLessonSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy quiz-results URL. Redirects to `/programs/{program}/{module}/{lesson}/results/{attemptId}`.
 * Attempts under a single-lesson space have no module slug — those stay on the legacy route.
 */
export const Route = createFileRoute(
  '/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/results/$attemptId',
)({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getLessonSlugPathQueryOptions(params.lessonId));
    const to = path.moduleSlug
      ? `/programs/${path.programSlug}/${path.moduleSlug}/${path.lessonSlug}/results/${params.attemptId}`
      : `/programs/${path.programSlug}/results/${params.attemptId}`;
    throw redirect({ to, replace: true });
  },
});
